import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import GameType from '../views/GameType.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/gameType',
    name: 'gameType',
    component: GameType
  }
]

const router = new VueRouter({
  routes
})

export default router
